/* VIRANIX i18n loader v1 – csak nem magyar nyelvű oldalakon fut.
   Betölti az eredeti szkriptet, a szöveges literálokat a szótár alapján lecseréli, majd lefuttatja.
   Használat: <script src="vx-i18n.js" data-src="eredeti.js" data-dict="sz1.txt sz2.txt" data-lang="en" defer></script>
   Szótár formátum (UTF-8, soronként): kulcs<TAB>angol<TAB>német   (\n = sortörés, \t = tab, \\ = backslash)
   Kulcs: FNV-1a 32 (base36) + hossz (base36) a literál nyers (forráskódbeli) tartalmán. */
(function () {
  var me = document.currentScript;
  if (!me) return;
  var src = me.getAttribute('data-src'), lang = me.getAttribute('data-lang') || 'en';
  var dicts = (me.getAttribute('data-dict') || '').split(/\s+/).filter(Boolean);
  var col = lang === 'de' ? 2 : 1;

  function get(u) {
    try { var x = new XMLHttpRequest(); x.open('GET', u, false); x.send(null); return (x.status >= 200 && x.status < 300) ? x.responseText : null; }
    catch (e) { return null; }
  }
  function run(code) {
    var s = document.createElement('script');
    s.text = code;
    window.__vxcs = { src: new URL(src, location.href).href, getAttribute: function (n) { return me.getAttribute(n); }, dataset: me.dataset };
    me.parentNode.insertBefore(s, me.nextSibling);
    window.__vxcs = null;
  }
  function fallback() { var s = document.createElement('script'); s.src = src; me.parentNode.insertBefore(s, me.nextSibling); }

  function key(raw) {
    var h = 0x811c9dc5;
    for (var i = 0; i < raw.length; i++) { h ^= raw.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return h.toString(36) + raw.length.toString(36);
  }
  function unesc(s) { return s.replace(/\\([nt\\])/g, function (m, c) { return c === 'n' ? '\n' : c === 't' ? '\t' : '\\'; }); }
  function enc(t, q) {
    t = t.replace(/\\/g, '\\\\').replace(/\r/g, '\\r').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
    if (q === '`') return t.replace(/`/g, '\\`').replace(/\$\{/g, '\\${');
    return t.replace(/\n/g, '\\n').split(q).join('\\' + q);
  }

  // Minimal JS lexer: yields string literals [start,end,q] (quotes included) and template quasis [start,end,'`'] (body only).
  var KW = /^(return|typeof|case|do|else|in|of|new|delete|void|throw|instanceof|yield|await)$/;
  function scan(c) {
    var out = [], i = 0, n = c.length, stack = [], prev = 'op', ch;
    function tmpl() { // at position after ` or }
      var st = i;
      while (i < n) {
        ch = c[i];
        if (ch === '\\') { i += 2; continue; }
        if (ch === '`') { out.push([st, i, '`']); i++; prev = 'val'; return; }
        if (ch === '$' && c[i + 1] === '{') { out.push([st, i, '`']); i += 2; stack.push('t'); prev = 'op'; return; }
        i++;
      }
    }
    while (i < n) {
      ch = c[i];
      if (ch === ' ' || ch === '\t' || ch === '\n' || ch === '\r' || ch === '\u2028' || ch === '\u2029' || ch === '\ufeff' || ch === '\u00a0') { i++; continue; }
      if (ch === '/' && c[i + 1] === '/') { while (i < n && c[i] !== '\n') i++; continue; }
      if (ch === '/' && c[i + 1] === '*') { var e = c.indexOf('*/', i + 2); i = e < 0 ? n : e + 2; continue; }
      if (ch === '"' || ch === "'") {
        var s0 = i; i++;
        while (i < n && c[i] !== ch) { if (c[i] === '\\') i++; i++; }
        i++; out.push([s0, i, ch]); prev = 'val'; continue;
      }
      if (ch === '`') { i++; tmpl(); continue; }
      if (ch === '{') { stack.push('b'); i++; prev = 'op'; continue; }
      if (ch === '}') { var top = stack.pop(); i++; if (top === 't') { tmpl(); } else prev = 'brace'; continue; }
      if (ch === '/') {
        if (prev === 'op' || prev === 'kw' || prev === 'brace') {
          i++; var cls = false;
          while (i < n) { var d = c[i]; if (d === '\\') { i += 2; continue; } if (d === '[') cls = true; else if (d === ']') cls = false; else if (d === '/' && !cls) break; else if (d === '\n') break; i++; }
          i++; while (i < n && /[a-z]/i.test(c[i])) i++;
          prev = 'val'; continue;
        }
        i++; prev = 'op'; continue;
      }
      if (/[A-Za-z_$À-￿]/.test(ch)) {
        var w0 = i; while (i < n && /[\w$À-￿]/.test(c[i])) i++;
        prev = KW.test(c.slice(w0, i)) ? 'kw' : 'val'; continue;
      }
      if (/[0-9]/.test(ch) || (ch === '.' && /[0-9]/.test(c[i + 1]))) { while (i < n && /[\w.]/.test(c[i])) i++; prev = 'val'; continue; }
      if (ch === ')' || ch === ']') { i++; prev = 'val'; continue; }
      i++; prev = 'op';
    }
    return out;
  }

  function translate(code, D) {
    var lits = scan(code), parts = [], last = 0, hit = 0;
    for (var k = 0; k < lits.length; k++) {
      var L = lits[k], q = L[2];
      var a = q === '`' ? L[0] : L[0] + 1, b = q === '`' ? L[1] : L[1] - 1;
      var t = D[key(code.slice(a, b))];
      if (t == null) continue;
      parts.push(code.slice(last, a), enc(t, q)); last = b; hit++;
    }
    parts.push(code.slice(last));
    return parts.join('').replace(/document\.currentScript/g, 'window.__vxcs');
  }
  window.__vxI18nScan = scan; window.__vxI18nKey = key; // tesztekhez

  // A CDN a .js fájlokat minifikálja (más idézőjel, \u-escape) – a kulcsok a forrásra szólnak, ezért a változatlan .src.txt másolatot töltjük be.
  var code = get(src.replace(/\.js(?=\?|$)/, '.src.txt'));
  if (code == null) code = get(src);
  if (code == null) return fallback();
  try {
    var D = {};
    for (var j = 0; j < dicts.length; j++) {
      var txt = get(dicts[j]);
      if (!txt) continue;
      var lines = txt.split('\n');
      for (var m = 0; m < lines.length; m++) {
        var f = lines[m].split('\t');
        if (f.length >= 3 && f[0] && f[col] !== '') D[f[0]] = unesc(f[col].replace(/\r$/, ''));
      }
    }
    run(translate(code, D));
  } catch (e) {
    if (window.console) console.warn('vx-i18n:', e);
    run(code.replace(/document\.currentScript/g, 'window.__vxcs'));
  }
})();
